module.exports = {
  baseUrl: 'https://www.rongfanjs.com/',
  onlineUrl: 'https://www.rongfanjs.com/',
  // baseUrl: 'http://192.168.130.6:8088/',
  // onlineUrl: 'http://192.168.130.6:8088/',
  projectName: '苏州荣帆建设工程办公系统',
  filingNumber: '苏ICP备20044537号-3'
}
